import { checkStockRSP } from "../Shared/ProductDetails";
import { cookie } from "../Shared/Cookie";
namespace ButtonProductDetails {
    declare const pConf: any;
    var siteId = 15;
    jQuery(function () {
        const productLogKey = "productLog";
        checkStockRSP(siteId);
        try {
            let array = cookie.GetFromJson<Array<number>>(productLogKey);
            if (array == null) {
                array = new Array<number>();
            }

            if (array.indexOf(pConf.productId) == -1) {
                array.push(pConf.productId);
                cookie.SetToJson(productLogKey, array);
            }
        }
        catch
        {
        }
    });
} 